// Media management routes
import APIVOD from '../../components/APIVOD.vue'
import VideoUploader from '../../components/VideoUploader.vue'
import ImageUploaderDemo from '../../components/ImageUploaderDemo.vue'

export default [
  {
    path: '/videos',
    name: 'APIVOD',
    component: APIVOD,
    meta: { 
      requiresAuth: true,
      title: 'Video Management'
    }
  },
  {
    path: '/videos/upload',
    name: 'VideoUpload',
    component: VideoUploader,
    meta: { 
      requiresAuth: true,
      title: 'Upload Video'
    }
  },
  {
    path: '/image-uploader',
    name: 'ImageUploaderDemo',
    component: ImageUploaderDemo,
    meta: { 
      requiresAuth: true,
      title: 'Image Uploader'
    }
  }
] 